import React from 'react';
import './TextSettingsSection.css';

// Bereinigte Text-Effekte Liste (10 Effekte)
const textEffects = [
    {
        id: 'none',
        name: 'None',
        preview: 'Aa',
        styles: {}
    },
    {
        id: 'gold-gradient',
        name: 'Gold Gradient',
        preview: 'Aa',
        styles: {
            background: 'linear-gradient(135deg, #FFD700 0%, #FFA500 50%, #FF8C00 100%)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            backgroundClip: 'text'
        }
    },
    {
        id: 'gold-luxury',
        name: 'Gold Luxury',
        preview: 'Aa',
        styles: {
            background: 'linear-gradient(135deg, #D4AF37 0%, #FFD700 20%, #FFA500 40%, #B8860B 60%, #FFD700 80%, #D4AF37 100%)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            backgroundClip: 'text'
        }
    },
    {
        id: 'gold-glow',
        name: 'Gold Glow',
        preview: 'Aa',
        styles: {
            color: '#FFD700',
            textShadow: '0 0 8px rgba(255, 215, 0, 0.6), 0 0 16px rgba(255, 215, 0, 0.4), 0 0 24px rgba(255, 215, 0, 0.2)'
        }
    },
    {
        id: 'gold-royal',
        name: 'Gold Royal',
        preview: 'Aa',
        styles: {
            background: 'linear-gradient(90deg, #B8860B 0%, #DAA520 15%, #FFD700 30%, #FFA500 45%, #FFD700 60%, #DAA520 75%, #B8860B 90%)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            backgroundClip: 'text'
        }
    },
    {
        id: 'gold-elegant',
        name: 'Gold Elegant',
        preview: 'Aa',
        styles: {
            color: '#B8860B',
            textShadow: '1px 1px 2px rgba(218, 165, 32, 0.3), 0 0 6px rgba(255, 215, 0, 0.2), 2px 2px 4px rgba(0, 0, 0, 0.1)'
        }
    },
    {
        id: 'gold-vintage',
        name: 'Gold Vintage',
        preview: 'Aa',
        styles: {
            background: 'radial-gradient(ellipse at center, #FFD700 0%, #DAA520 30%, #B8860B 60%, #8B7355 100%)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            backgroundClip: 'text'
        }
    },
    {
        id: 'silver-gradient',
        name: 'Silver Gradient',
        preview: 'Aa',
        styles: {
            background: 'linear-gradient(135deg, #E5E7EB 0%, #9CA3AF 50%, #6B7280 100%)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            backgroundClip: 'text'
        }
    },
    {
        id: 'blue-glow',
        name: 'Blue Glow',
        preview: 'Aa',
        styles: {
            color: '#3B82F6',
            textShadow: '0 0 6px rgba(59, 130, 246, 0.3), 0 0 12px rgba(59, 130, 246, 0.2), 0 0 18px rgba(59, 130, 246, 0.1)',
            animation: 'glowPulse 2s ease-in-out infinite'
        }
    },
    {
        id: 'purple-glow',
        name: 'Purple Glow',
        preview: 'Aa',
        styles: {
            color: '#8B5CF6',
            textShadow: '0 0 6px rgba(139, 92, 246, 0.3), 0 0 12px rgba(139, 92, 246, 0.2), 0 0 18px rgba(139, 92, 246, 0.1)',
            animation: 'glowPulse 2.5s ease-in-out infinite'
        }
    },
    {
        id: 'elegant-shadow',
        name: 'Elegant Shadow',
        preview: 'Aa',
        styles: {
            textShadow: '2px 2px 4px rgba(0, 0, 0, 0.3), 0 0 8px rgba(0, 0, 0, 0.1)'
        }
    },
    {
        id: 'deep-shadow',
        name: 'Deep Shadow',
        preview: 'Aa',
        styles: {
            textShadow: '4px 4px 8px rgba(0, 0, 0, 0.5), 2px 2px 4px rgba(0, 0, 0, 0.3)'
        }
    },
    {
        id: 'neon-pink',
        name: 'Neon Pink',
        preview: 'Aa',
        styles: {
            color: '#FF1493',
            textShadow: '0 0 4px #FF1493, 0 0 8px rgba(255, 20, 147, 0.4), 0 0 12px rgba(255, 20, 147, 0.2)',
            animation: 'glowPulse 1.8s ease-in-out infinite'
        }
    },
    {
        id: 'neon-red',
        name: 'Neon Red',
        preview: 'Aa',
        styles: {
            color: '#FF073A',
            textShadow: '0 0 6px #FF073A, 0 0 12px rgba(255, 7, 58, 0.5), 0 0 18px rgba(255, 7, 58, 0.3)',
            animation: 'neonRedPulse 2.2s ease-in-out infinite'
        }
    },
    {
        id: 'neon-yellow',
        name: 'Neon Yellow',
        preview: 'Aa',
        styles: {
            color: '#FFFF00',
            textShadow: '0 0 6px #FFFF00, 0 0 12px rgba(255, 255, 0, 0.5), 0 0 18px rgba(255, 255, 0, 0.3)',
            animation: 'neonYellowPulse 1.8s ease-in-out infinite'
        }
    },
    {
        id: 'holistic-earth',
        name: 'Holistic Earth',
        preview: 'Aa',
        styles: {
            background: 'linear-gradient(135deg, #8B7355 0%, #A0956B 25%, #B8A678 50%, #A0956B 75%, #8B7355 100%)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            backgroundClip: 'text',
            animation: 'holisticFlow 8s ease-in-out infinite'
        }
    },
    {
        id: 'holistic-sage',
        name: 'Holistic Sage',
        preview: 'Aa',
        styles: {
            color: '#87A96B',
            textShadow: '0 0 8px rgba(135, 169, 107, 0.3), 0 2px 6px rgba(135, 169, 107, 0.2)',
            animation: 'sageBreath 4s ease-in-out infinite'
        }
    },
    {
        id: 'holistic-crystal',
        name: 'Holistic Crystal',
        preview: 'Aa',
        styles: {
            background: 'linear-gradient(45deg, #E6E6FA 0%, #DDA0DD 25%, #DA70D6 50%, #DDA0DD 75%, #E6E6FA 100%)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            backgroundClip: 'text',
            animation: 'crystalShimmer 6s ease-in-out infinite'
        }
    },
    {
        id: 'holistic-moonlight',
        name: 'Holistic Moonlight',
        preview: 'Aa',
        styles: {
            color: '#F0F8FF',
            textShadow: '0 0 10px rgba(240, 248, 255, 0.4), 0 0 20px rgba(240, 248, 255, 0.2)',
            animation: 'moonlightGlow 5s ease-in-out infinite'
        }
    },
    {
        id: 'holistic-golden-aura',
        name: 'Golden Aura',
        preview: 'Aa',
        styles: {
            background: 'radial-gradient(circle, #FFD700 0%, #FFA500 30%, #FF8C00 60%, #FFD700 100%)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            backgroundClip: 'text',
            animation: 'goldenAura 7s ease-in-out infinite'
        }
    },
    {
        id: 'embossed',
        name: 'Embossed',
        preview: 'Aa',
        styles: {
            color: '#f0f0f0',
            textShadow: '1px 1px 0px #ccc, 2px 2px 0px #c9c9c9, 3px 3px 0px #bbb, 4px 4px 0px #b9b9b9, 5px 5px 0px #aaa, 6px 6px 1px rgba(0,0,0,.1), 0 0 5px rgba(0,0,0,.1), 1px 1px 3px rgba(0,0,0,.3), 3px 3px 5px rgba(0,0,0,.2), 5px 5px 10px rgba(0,0,0,.25)'
        }
    },
    {
        id: 'crimson-gradient',
        name: 'Crimson Gradient',
        preview: 'Aa',
        styles: {
            background: 'linear-gradient(135deg, #DC143C 0%, #B22222 50%, #8B0000 100%)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            backgroundClip: 'text'
        }
    },
    {
        id: 'rose-glow',
        name: 'Rose Glow',
        preview: 'Aa',
        styles: {
            color: '#E91E63',
            textShadow: '0 0 6px rgba(233, 30, 99, 0.4), 0 0 12px rgba(233, 30, 99, 0.3), 0 0 18px rgba(233, 30, 99, 0.2)',
            animation: 'roseGlow 3s ease-in-out infinite'
        }
    },
    {
        id: 'fire-gradient',
        name: 'Fire Gradient',
        preview: 'Aa',
        styles: {
            background: 'linear-gradient(135deg, #FF4500 0%, #FF6347 25%, #FF0000 50%, #DC143C 75%, #B22222 100%)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            backgroundClip: 'text',
            animation: 'fireFlow 4s ease-in-out infinite'
        }
    },
    {
        id: 'ruby-shadow',
        name: 'Ruby Shadow',
        preview: 'Aa',
        styles: {
            color: '#CC0000',
            textShadow: '2px 2px 4px rgba(204, 0, 0, 0.4), 0 0 8px rgba(204, 0, 0, 0.2), 4px 4px 8px rgba(139, 0, 0, 0.3)'
        }
    }
];

function InlineTextEffects({ 
    fieldName, 
    currentEffect, 
    onChange
}) {
    const handleEffectSelect = (effectId) => {
        onChange({ target: { name: fieldName, value: effectId } });
    };

    return (
        <div className="inline-text-effects">
            <div className="inline-effects-header">
                <span className="inline-effects-label">✨ Text Effects</span>
            </div>
            
            <div className="inline-effects-grid">
                {textEffects.map(effect => (
                    <div 
                        key={effect.id} 
                        className={`inline-effect-option ${currentEffect === effect.id ? 'selected' : ''}`}
                        onClick={() => handleEffectSelect(effect.id)}
                        title={effect.name}
                    >
                        <div 
                            className="inline-effect-preview"
                            style={effect.styles}
                        >
                            {effect.preview}
                        </div>
                        <span className="inline-effect-name">{effect.name}</span>
                    </div>
                ))}
            </div>
        </div>
    );
}

export default InlineTextEffects;